import React from 'react';

const Pagination = ({ totalPages, currentPage, handlePageClick }) => {
    const generatePageNumbers = () => {
        const pages = [];
        const totalPageNumbers = 7; // Adjust this to show more or fewer pages

        if (totalPages <= totalPageNumbers) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            const startPages = [1, 2];
            const endPages = [totalPages - 1, totalPages];
            const middlePages = [];

            if (currentPage > 3 && currentPage < totalPages - 2) {
                middlePages.push(currentPage - 1, currentPage, currentPage + 1);
            } else if (currentPage <= 3) {
                middlePages.push(3, 4, 5);
            } else if (currentPage >= totalPages - 2) {
                middlePages.push(totalPages - 4, totalPages - 3, totalPages - 2);
            }

            if (currentPage > 4) {
                startPages.push('...');
            }

            if (currentPage < totalPages - 3) {
                endPages.unshift('...');
            }

            pages.push(...startPages, ...middlePages, ...endPages);
        }

        return pages;
    };

    const pageNumbers = generatePageNumbers();

    return (
        <div className="pagination">
            <button
                onClick={() => handlePageClick(1)}
                disabled={currentPage === 1}
            >
                First
            </button>
            <button
                onClick={() => handlePageClick(currentPage - 1)}
                disabled={currentPage === 1}
            >
                Previous
            </button>
            {pageNumbers.map((page, index) => (
                <button
                    key={index}
                    onClick={() => typeof page === 'number' && handlePageClick(page)}
                    disabled={currentPage === page || page === '...'}
                >
                    {page}
                </button>
            ))}
            <button
                onClick={() => handlePageClick(currentPage + 1)}
                disabled={currentPage === totalPages}
            >
                Next
            </button>
            <button
                onClick={() => handlePageClick(totalPages)}
                disabled={currentPage === totalPages}
            >
                Last
            </button>
        </div>
    );
};

export default Pagination;
